import { indexItems } from '@/mocks/home';

export default function SectionIndex() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              专题索引
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href="#index"
                className="flex items-start gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-primary-600 text-lg`}></i>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                    <span className="text-[10px] text-foreground-400 bg-background-200/50 px-2 py-0.5 rounded-full whitespace-nowrap shrink-0 ml-2">
                      {item.count}部
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}